import { DataTableRow, DataTableRowProps } from "@rmwc/data-table";
import React, { FC } from "react";

import { Cell } from "./Cell";
import { CellModel } from "./utils";

import style from "./style.scss";

export interface RowProps extends DataTableRowProps {
    readonly key: string | number;
    readonly cells: readonly CellModel[];
    readonly prioritize?: boolean;
    search?(key: string): void;
}

const RowInner: FC<RowProps> = (props: RowProps) => {
    const { cells, prioritize, search, ...rowProps } = props;

    return (
        <DataTableRow className={`${prioritize ? style.rowPrioritize : style.row}`} {...rowProps}>
            {cells.map((cellData: CellModel, i: number) => {
                return <Cell key={i} {...cellData} search={search} />;
            })}
        </DataTableRow>
    );
};

const Row = React.memo(RowInner);
export { Row };
